/** @format */

import {useNavigate} from 'react-router-dom';

import {WidgetSettingsButton} from 'components/PropertyWidget/components/WidgetSettingsButton';

interface Props {
  bgColor: string;
  companyId: string;
}

const WidgetSensorButtonWrap = ({bgColor, companyId}: Props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/home/project/sensors?companyId=${companyId}&edit=1`);
  };

  return <WidgetSettingsButton bgColor={bgColor} onClick={handleClick} />;
};

export {WidgetSensorButtonWrap};
